<script setup>
import AffiliationTable from '@frontJs/components/tables/projectManagement/apikom/AffiliationTable.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import TabLayout from '@js/components/tabs/TabLayout.vue';
import PageTitle from '@js/components/titles/PageTitle.vue';
import { h } from 'vue';

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>Affiliations - Apikom - Gestion de projet - Datakepler</title>
    </Head>

    <PageTitle> Gestion de projet - Apikom - Affiliations </PageTitle>

    <TabLayout
        :tabs="{
            all: {
                title: 'Tous',
                content: h(AffiliationTable),
            },
            archived: {
                title: 'Archivé',
                content: h(AffiliationTable, { archived: true }),
            },
        }"
    />
</template>
